import React from 'react';

type JourneyInputVariant = 'default' | 'money';

export interface JourneyTextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
  variant?: JourneyInputVariant;
}

function cx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ');
}

export const JourneyTextArea: React.FC<JourneyTextAreaProps> = ({
  className,
  hasError = false,
  variant = 'default',
  ...props
}) => {
  const variantClassName =
    variant === 'money'
      ? cx('money-form-field__control', 'money-form-field__control--textarea')
      : '';

  return (
    <textarea
      {...props}
      className={cx(
        variantClassName,
        variant === 'money' && hasError && 'is-error',
        className,
      )}
    />
  );
};

export const TextArea = JourneyTextArea;

export default JourneyTextArea;
